import { useCallback, useEffect, useState } from 'react'
import { Box, Grid } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatment-courses/treatment-course-types/style'

/** API */
import TemplateFormsApi, { IFTemplateFormsProps } from 'api/setting/doctor-note/template-forms.api'

/** UTILS || SLICE */
import { showModal } from 'app/slice/modal.slice'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextSearch from 'component/Input/InputTextSearch'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'

import ModalTemplateForm from './modal-template-form'
import _ from 'lodash'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'


const initStateErrorMessage = {
    TEMPLATE_FORM_NAME: ``,
    IS_DUPLICATE_TEMPLATE_FORM_NAME: ``,
    TEMPLATE_FORM_NAME_STRING_BASE: ``,
    TEMPLATE_FORM_NAME_STRING_EMPTY: ``,
    TEMPLATE_FORM_NAME_MAXIMUM_LENGTH: ``,
    TEMPLATE_FORM_NAME_ANY_REQUIRED: ``,

    TEMPLATE_FORM_NAME_EN: ``,
    IS_DUPLICATE_TEMPLATE_FORM_NAME_EN: ``,
    TEMPLATE_FORM_NAME_EN_STRING_BASE: ``,
    TEMPLATE_FORM_NAME_EN_STRING_EMPTY: ``,
    TEMPLATE_FORM_NAME_EN_MAXIMUM_LENGTH: ``,
    TEMPLATE_FORM_NAME_EN_ANY_REQUIRED: ``
}
export default function TemplateForm() {
    const classes = useStyles()
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [templateForms, setTemplateForms] = useState<IFTemplateFormsProps[]>([])
    const [dataModal, setDataModal] = useState<{ isShow: boolean, data: any[], view?: any }>({ isShow: false, data: [], })


    /** PAGINATION  */
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createdAt')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('ALL')

    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [statusAlertModal, setStatusAlertModal] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')

    const loadData = useCallback(async () => {
        let condition: any = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
        if (search) condition = { ...condition, search: search }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

        const res = await TemplateFormsApi.findAll(condition)
        if (res.status === 200) {
            setRowCount(res.headers['x-total'])
            setTemplateForms(res.data)
        }
    }, [page, pageLimit, search, sortBy, sortType, status])

    useEffect(() => {
        loadData()
    }, [loadData])

    useEffect(() => {

        const filtered = templateForms.filter(entry => entry.name.includes(search));
        setTemplateForms(filtered)
    }, [search])


    const resetPopup = () => {
        setDataModal({ isShow: false, data: [] })
        loadData()
    }


    const onActive = () => {
        if (id) {
            TemplateFormsApi.updateStatus(id, statusAlertModal).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('IMAGE_DOCTOR_NOT.MESSAGE.SUCCESS.UPDATE_STATUS'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('IMAGE_DOCTOR_NOT.MESSAGE.ERROR'))
                }
            })
        }
    }
    const onDelete = () => {

        if (id) {
            TemplateFormsApi.remove(id).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('TEMPLATE_FORM.MESSAGE.SUCCESS.DELETE'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('TEMPLATE_FORM.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onCreate = () => {
        setDataModal({ isShow: true, data: [] })
        dispatch(showModal())
    }
    const onEdit = (data: any) => {
        setDataModal({ isShow: true, data })
        dispatch(showModal())
    }
    const onView = (e: any, objVal: any) => {
        const data = objVal
        setDataModal({ isShow: true, data, view: true })
        dispatch(showModal())
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => {
        setPage(val)
    }

    const handleChangeRowsPerPage = (limit: number) => {
        setPageLimit(limit)
    }
    const handleChangeStatus = (statusVal: string) => {
        setStatus(statusVal)
    }
    const headCells = [
        { id: 'no', disablePadding: false, label: '#' },
        { id: 'treatmentCourseTypeName', disablePadding: false, label: t('TEMPLATE_FORM.TABLE.CELL.TEMPLATE_FORM_NAME') },
        { id: 'templateFormName', disablePadding: false, label: t('TEMPLATE_FORM.TABLE.CELL.TEMPLATE_FORM_NAME_EN') },
        { id: 'status', disablePadding: false, label: t('TEMPLATE_FORM.TABLE.CELL.STATUS') },
        { id: 'updatedBy', disablePadding: false, label: t('TEMPLATE_FORM.TABLE.CELL.UPDATED_BY') },
        { id: 'action', disablePadding: false, label: 'Action' }
    ]

    const renderData = (objData: IFTemplateFormsProps, no: number, valueExportData: boolean) => {
        const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
        const { templateFormsId, name, templateFormType, updatedBy, updatedAt, status: dcTypeStatus } = objData
        const statusBtnActive = dcTypeStatus === 'ACTIVE' ? true : false
        const statusBtnInActive = dcTypeStatus === 'INACTIVE' ? true : false
        const objRenderData = {
            key: String(templateFormsId),
            id: String(templateFormsId),
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: num },
                { option: 'TEXT', align: 'left', label: templateFormType.typeName || '-' },
                { option: 'TEXT', align: 'left', label: name || '-' },
                { option: 'STATUS', align: 'center', label: dcTypeStatus },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
                        { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
                        { option: 'DIVIDER', label: '', disabled: false },
                        { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: false },
                        { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: false }
                    ]
                }
            ]
        }
        return <TableRowCommon
            {...objRenderData}
            rowLink={true}
            onClick={(e, val) => onView(e, val)}
            onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
            oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            onedit={() => onEdit(objRenderData.obj)}
            ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
        />
    }

    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        setStatusAlertModal(status)
        setId(id)
        setIsOpenAlertModal(true)
        setName(obj.name)
    }

    return (
        <div className={classes.root}>
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`TEMPLATE_FORM.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
                message={t(`TEMPLATE_FORM.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { name: name, status: t(`TEMPLATE_FORM.ALERT.${statusAlertModal}`) })}
                type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <Box className="" sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#fff', borderRadius: '0.25rem', height: '100%' }}>
                <HeaderCard text={t('TEMPLATE_FORM.TITLE')} />
                <Box sx={{ flex: '1 1 auto', p: '16px' }}>
                    <Box sx={{ mb: 0, pl: { xl: '16px' } }}>
                        <Grid container sx={{ alignItems: 'center' }}>
                            <Grid item md={8}>
                                <Grid container className="flax-row">
                                    <Grid item sm={12} md={6} xl={4} sx={{ pt: '8px' }}>
                                        <InputTextSearch
                                            keyInput={'search'}
                                            label={t('TEMPLATE_FORM.SEARCH')}
                                            value={search}
                                            onchange={(event) => {
                                                setSearch(event.target.value)
                                                setPage(1)
                                            }}
                                            onClear={(event) => {
                                                setSearch('')
                                                setPage(1)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={6} xl={4} sx={{ pl: { md: 0 }, pt: '8px' }}>
                                        <FilterSelect
                                            formControlClass='not-max-width'
                                            onchange={(event) => {
                                                const value = event.target.value
                                                if (value) {
                                                    handleChangeStatus(value)
                                                    setPage(1)
                                                }
                                            }}
                                            renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                                            label={t('STATUS.LABEL')}
                                            selectId="select-status"
                                            value={status}
                                            labelId="label-status"
                                            options={[
                                                <MenuItem key="1" value="ALL">
                                                    {t('STATUS.ALL')}
                                                </MenuItem>,
                                                <MenuItem key="2" value="ACTIVE">
                                                    {t('STATUS.ACTIVE')}
                                                </MenuItem>,
                                                <MenuItem key="3" value="INACTIVE">
                                                    {t('STATUS.INACTIVE')}
                                                </MenuItem>
                                            ]}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={4} sx={{ mt: { xs: '8px', md: 'auto' } }}>
                                <Box sx={{ pr: { xl: '8px' }, display: 'flex' }}>
                                    <Box sx={{ pl: '16px', ml: 'auto' }}>
                                        <ButtonCustom mode="add" onClick={onCreate} textButton={t('TEMPLATE_FORM.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" btnStyle={{ height: '44px' }} />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <div className={'mt-3 pl-xl-3 pr-xl-2'}>
                        <TableCustom
                            page={page}
                            pageLimit={pageLimit}
                            sortType={sortType}
                            sortBy={sortBy}
                            onSort={onRequestSort}
                            setPageLimit={handleChangeRowsPerPage}
                            setPage={handleChangePage}
                            rowCount={rowCount}
                            headCells={headCells}
                            rowsData={
                                _.map(templateForms, renderData)}
                        />
                    </div>
                </Box>
            </Box>
            <ModalTemplateForm  {...dataModal} callback={loadData} resetPopup={resetPopup} />

        </div>
    )
}
